import AddRounded from '@mui/icons-material/AddRounded';
import RemoveRounded from '@mui/icons-material/RemoveRounded';
import RoundIconButton from 'components/common/RoundIconButton/RoundIconButton';
import './Counter.module.scss';

// A stepper: − and + either side of a large number, between min and max.
// labels names the two buttons, e.g. ['Fewer walkers', 'More walkers'].
const TSCounter = ({
  count,
  setCount,
  min = 0,
  max = 20,
  labels = ['Fewer', 'More'],
}) => (
  <div className="ts-stepper">
    <RoundIconButton
      icon={<RemoveRounded />}
      label={labels[0]}
      disabled={count <= min}
      onClick={() => setCount((prev) => Math.max(prev - 1, min))}
    />
    <output className="ts-stepper__value" aria-live="polite">
      {count}
    </output>
    <RoundIconButton
      icon={<AddRounded />}
      label={labels[1]}
      disabled={count >= max}
      onClick={() => setCount((prev) => Math.min(prev + 1, max))}
    />
  </div>
);

export default TSCounter;
